import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFinances = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.b{stroke:#24a81b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H40V40H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M6,15.667V9H19.333v6.667",
			transform: "translate(4 6)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M18.667,11.667h1.667V5H7v6.667",
			transform: "translate(4.667 3.333)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M22.381,14.953a6.667,6.667,0,1,1-9.428,0,6.667,6.667,0,0,1,9.428,0",
			transform: "translate(7.333 8.667)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M6,17v6.667H21",
			transform: "translate(4 11.333)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M21.667,13H5v6.667H15",
			transform: "translate(3.333 8.667)"
		})
	]
});
export default SvgFinances;
